import { Alert } from '@capsicum/common-web';
import { useNCWSendChzAlert } from '@capsicum/features/nc-wallet/shared';

import { CustomInfoIcon } from '../ncw-test-before-send-alert';

export const NCWSendChzAlert = () => {
	const { intlText } = useNCWSendChzAlert();

	return (
		<Alert
			closable={false}
			icon={CustomInfoIcon}
			subTitle={intlText.alertSubtitle}
			title={intlText.alertTitle}
			type="message"
		/>
	);
};
